<template>
  <div>
    <form autocomplete="off"
          class="px-2 mt-2 pt-2">
      <div class="row">
        <div class="col-12 col-sm-5">
          <div class="form-group">
            <label class="label"
                   for="nome">CPF</label>
            <input id="nome"
                   ref="nascido_nome"
                   v-model="pessoa.cpf"
                   v-mask="'999.999.999-99'"
                   class="form-control form-control-sm text-uppercase"
                   name="cpf"
                   placeholder="000.000.000-00"
                   :disabled="pessoa.cpf_origem == 'CRC'"
                   type="text"
                   @change="cpfChange()">
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-sm-5">
          <div class="form-group">
            <label class="label"
                   :class="{'label_error': error_nome}"
                   for="nome">Nome
              <IconSvg v-if="error_nome"
                       class="icon-error-campo"
                       icon="alert" />
            </label>
            <input id="nome"
                   v-model="pessoa.nome"
                   v-validate="'required'"
                   :class="{ 'is-invalid': errors.has('nome') || error_nome }"
                   class="form-control form-control-sm text-uppercase"
                   name="nome"
                   placeholder="Enzo Silva"
                   required
                   type="text"
                   @change="changeData">
            <small v-if="errors.has('nome')"
                   class="invalid-feedback">{{ errors.first('nome') }}</small>
          </div>
        </div>

        <div class="col-12 col-sm-3">
          <div class="form-group">
            <label class="label"
                   :class="{'label_error': error_data}"
                   for="dataNascimento">Data Nascimento
              <IconSvg v-if="error_data"
                       class="icon-error-campo"
                       icon="alert" />
            </label>
            <input id="dataNascimento"
                   v-model="pessoa.data_nascimento"
                   v-mask="'##/##/####'"
                   v-validate="`required|date_format:dd/MM/yyyy|date_between:01/01/1500,${limitDate}|max_date:${new Date()}`"
                   class="form-control form-control-sm"
                   :class="{ 'is-invalid': errors.has('dataNascimento') || error_data}"
                   maxlength="10"
                   name="dataNascimento"
                   placeholder="00/00/0000"
                   required
                   type="text"
                   @change="getIdadeMae">
            <small v-if="errors.has('dataNascimento')"
                   class="invalid-feedback">{{ errors.first('dataNascimento') }}</small>
          </div>
        </div>

        <div class="col-12 col-lg-2 col-sm-3">
          <div class="form-group">
            <label class="label"
                   for="horaNascimento">Hora Nascimento</label>
            <input id="horaNascimento"
                   v-model="registro.hora_ocorrido"
                   v-mask="'99:99'"
                   v-validate="'validateHour'"
                   class="form-control form-control-sm"
                   :class="{ 'is-invalid': errors.first('horaNascimento') }"
                   maxlength="5"
                   name="horaNascimento"
                   placeholder="00:00"
                   type="text"
                   @change="changeData">
            <small v-if="errors.has('horaNascimento')"
                   class="invalid-feedback">{{ errors.first('horaNascimento') }}</small>
          </div>
        </div>

        <div class="col-12 col-lg-2 col-sm-3">
          <div class="form-group">
            <label class="label"
                   :class="{'label_error': error_sexo}"
                   for="sexoNascido">Sexo
              <IconSvg v-if="error_sexo"
                       class="icon-error-campo"
                       icon="alert" />
            </label>
            <select id="sexoNascido"
                    v-model="pessoa.sexo"
                    :class="{ 'is-invalid': errors.has('sexoNascido') || error_sexo }"
                    class="custom-select custom-select-sm"
                    name="sexoNascido"
                    @change="changeData">
              <option selected
                      value="">
                Selecione
              </option>
              <option v-for="sexo in SEXOS"
                      :key="sexo.value"
                      :value="sexo.value">
                {{ sexo.name }}
              </option>
            </select>
          </div>
        </div>
      </div>
    </form>
    <Genitores :genitores="genitores"
               :registro-parte="data.registro_id"
               :endereco-registrado="enderecoRegistrado"
               :campo-declarante="true"
               :read-only="true"
               :prop-validate="true"
               :prop-nascimento="true"
               :prop-cartorio="propCartorio"
               prop-tipo-registro="N"
               :prop-correcoes="propCorrecoes"
               :prop-data="{ registro: { pessoa: { data_nascimento: pessoa.data_nascimento } } }"
               @deleteError="deleteError"
               @genitorAdded="getGenitores"
               @genitorRemoved="removeGenitor"
               @genitorUpdated="updateGenitor"
               @removeDocumento="removeDocumento"
               @removeEndereco="removeEndereco"
               @deleteAvo="deleteAvo"
               @removeGenitorDeclarante="removeGenitorDeclarante" />

    <!--
    <Avos :prop-genitores="genitores"
          @changed="addAvos"
          @updateAvo="updateAvo"
          @deleteAvo="deleteAvo" />
    -->

    <!--  LOCAL OCORRêNCIA  -->
    <LocalOcorrencia :num-dnv="numero_declaracao_nascido_vivo"
                     :num-dnv-cadastrada="numDnvCadastrada"
                     :local="local"
                     :prop-birth-year="pessoa.data_nascimento"
                     :prop-cartorio="propCartorio"
                     :prop-correcoes="propCorrecoes"
                     @numDeclaracaoUpdated="updateNumDeclaracao"
                     @clearEditOcorrencia="clearEditOcorrencia"
                     @receiveOcorrencia="receiveOcorrencia"
                     @removeOcorrencia="removeOcorrencia"
                     @deleteError="deleteError" />

    <!-- Naturalidade -->
    <div>
      <div class="headerTitle mt-4 mb-3">
        <div class="d-flex justify-content-between align-items-center">
          <h4 class="headerTitleB2_title">
            Naturalidade
          </h4>
        </div>
      </div>
      <form autocomplete="off">
        <div class="col-12 p-0">
          <div class="col pb-2">
            <b-form-radio v-model="naturalidade_origem"
                          name="some-radios"
                          value="endereco_ocorrencia"
                          @change="changeTipoNaturalidade">
              A mesma do local da ocorrência
              <div class="row">
                <small v-if="naturalidadeControl.alerts.endereco_ocorrencia"
                       class="text-danger text-bold">- {{ naturalidadeControl.alerts.message }}</small>
              </div>
            </b-form-radio>
          </div>
          <div class="col pb-2">
            <b-form-radio v-model="naturalidade_origem"
                          name="some-radios"
                          value="endereco_mae"
                          @change="changeTipoNaturalidade">
              A mesma da residência cadastrada da mãe biológica
              <div class="row">
                <small v-if="naturalidadeControl.alerts.endereco_mae"
                       class="text-danger text-bold">- {{ naturalidadeControl.alerts.message }}</small>
              </div>
            </b-form-radio>
          </div>
          <div v-if="nome_pai"
               class="col pb-2">
            <b-form-radio v-model="naturalidade_origem"
                          name="some-radios"
                          value="endereco_pai"
                          @change="changeTipoNaturalidade">
              A mesma de <span class="text-capitalize">{{ nome_pai | firstCapitalize }}</span>
              <div class="row">
                <small v-if="naturalidadeControl.alerts.endereco_pai"
                       class="text-danger text-bold">- {{ naturalidadeControl.alerts.message }}</small>
              </div>
            </b-form-radio>
          </div>
        </div>
      </form>
    </div>

    <!--  GÊMEOS  -->
    <BoxFormGemeos :lista="gemeos"
                   :prop-matricula="registro.matricula"
                   :prop-ordem-nascimento="ordem_nascimento"
                   :prop-gemeos-crc="data.registro ? data.registro.pessoa.possui_gemeos_crc : false"
                   @addGemeo="addGemeo"
                   @removeGemeo="removeGemeo"
                   @cleanGemeos="cleanGemeos"
                   @updateGemeo="updateGemeo"
                   @changeOrdemNascimento="changeOrdemNascimento"
                   @updateFlag="updateFlag" />
  </div>
</template>

<script>
  /* components */
  import Genitores from '../../../Obito/Passos/Sessoes/Genitores.vue'
  import BoxFormGemeos from '../../BoxFormGemeos.vue'
  import LocalOcorrencia from '@/components/SofiaRei/Nascimento/LocalOcorrencia'

  /* constants */
  import SEXOS from '@/constants/sexos'
  import objSwal from "@/constants/swalValues"
  import Cidades from "@/constants/repositorio/cidades"

  /* utils */
  import {validateHour} from '@/utils/validation'

  /* services */
  import EnderecosService from "@/services/Enderecos"

  /* outros */
  import moment from "moment"

  export default {
    name: "AbaNascido",
    inject: ['$validator'],
    components: {
      Genitores,
      BoxFormGemeos,
      LocalOcorrencia
    },
    props: {
      data: {type: Object, default: () => ({})},
      propCartorio: {type: Object, default: () => ({})},
      propCorrecoes: {type: Object, default: () => ({})}
    },
    data () {
      return {
        id: null,
        numero_declaracao_nascido_vivo: this.data.numero_declaracao_nascido_vivo,
        numDnvCadastrada: null,
        ordem_nascimento: null,
        enderecoRegistrado: {},
        pessoa: {
          sexo: '',
          naturalida_origem: null,
          cpf_origem: null
        },
        limitDate: moment(new Date()).add(1, 'day').format('DD/MM/YYYY'),
        registro: {
          partes: [],
          pessoa: {
            genitores: {}
          },
          tipo_registro: 'N',
          local: {
            endereco: {}
          }
        },
        local: {},
        toEditLocalOcorrencia: {},
        gemeos: [],
        genitores: [],
        idade_mae: null,
        nome_pai: null,
        deleteds: { genitores: [], partes: [], gemeos: [], filiacao: [], pessoaDocumentos: [], pessoaEnderecos: [] },

        // FUTURAS ALTERAÇÕES
        localData: {
          nacionalidade: {
            codigo: 76,
            nome: 'Brasil',
            nome_masculino: 'brasileiro',
            nome_feminino: 'brasileira'
          }
        },
        naturalidade: '',
        naturalidade_origem: null,
        naturalidadeControl: {
          alerts: {
            endereco_ocorrencia: false,
            endereco_mae: false,
            endereco_pai: false,
            mensagem: null
          }
        },
        selectsOptions: {
          states: [],
          cities: [],
        },
        SEXOS,
        avosUpdate: [],
        error_nome: false,
        error_data: false,
        error_sexo: false,
        error_local_ocorrencia: false
      }
    },
    computed: {
      // FUTURAS ATUALIZAÇÕES
      citiesFiltered () {
        if (this.localData.uf) {
          const stateSelected = this.selectsOptions.states.find(state => state.uf === this.localData.uf)
          return this.selectsOptions.cities.filter(city => city.nome === 'Outro' || city.state_id === stateSelected.id)
        }
        return this.selectsOptions.cities
      },
    },
    watch: {
      data () {
        this.init()
      },
      propCorrecoes () {
        this.verifyErrorsCarga()
      },
      genitores () {
        this.getNomePai()
      }
    },
    beforeMount () {
      this.id = this._uid
    },
    async created () {
      this.selectsOptions.states = await EnderecosService.getStates()
      this.selectsOptions.cities = Cidades

      this.$validator.extend('validateHour', validateHour)
      this.init()
    },
    mounted () {
      this.verifyErrorsCarga()
    },
    methods: {
      init () {
        if (Object.entries(this.data).length) return this.setData(this.data)
      },
      changeOrdemNascimento (ordemNascimento) {
        this.ordem_nascimento = ordemNascimento

        this.changeData()
      },
      setData (obj) {
        if (!obj.nascimentoInformacao) {
          obj.nascimentoInformacao = {
            idade_mae: this.idade_mae,
            tipo_gravidez: null,
            tipo_parto: null,
            total_consultas_pre_natal: null,
            total_filhos_mortos_gestacoes_anteriores: null,
            total_filhos_vivos_gestacoes_anteriores: null,
            total_semanas_gestacao: null
          }
        }
        this.numero_declaracao_nascido_vivo = obj.numero_declaracao_nascido_vivo

        // Salvamos a dnv em outra variável para comparar a digitação nova e antiga no campo
        if (this.numero_declaracao_nascido_vivo) {
          this.numDnvCadastrada = this.numero_declaracao_nascido_vivo
        }

        this.localData.naturalidade = obj.registro.pessoa.naturalidade
        this.naturalidade = obj.registro.pessoa.naturalidade
        this.naturalidade_origem = obj.registro.pessoa.naturalidade_origem
        this.registro = { ...obj.registro }
        this.genitores = obj.registro.pessoa.genitores
        this.gemeos = obj.registro.pessoa.gemeos
        this.local = obj.registro.local || {}
        this.pessoa = {
          ...obj.registro.pessoa,
          data_nascimento: obj.registro.pessoa.data_nascimento ? moment(obj.registro.pessoa.data_nascimento).format('DD/MM/YYYY') : null
        }
        this.idade_mae = obj.nascimentoInformacao.idade_mae
        this.ordem_nascimento = obj.ordem_nascimento
      },
      changeData (event) {
        if (event) {
          if (event.target.name == 'nome') this.deleteError(['NOME DO NASCIDO', 'NOME DO REGISTRADO'])
          else if (event.target.name == 'dataNascimento') this.deleteError(['DATA DO NASCIMENTO', 'DATA DE NASCIMENTO'])
          else if (event.target.name == 'sexoNascido') this.deleteError(['SEXO DO NASCIDO', 'SEXO DO REGISTRADO'])
        }

        this.upperName()
        let obj = {
          ...this.data,
          deleteds: this.deleteds,
          nome_registrado: this.pessoa.nome,
          numero_declaracao_nascido_vivo: this.numero_declaracao_nascido_vivo ? this.numero_declaracao_nascido_vivo.replace('-', '').replace('-', '') : '',
          registro: {
            ...this.registro,
            pessoa: {
              ...this.pessoa,
              data_nascimento: moment(this.pessoa.data_nascimento, 'DD/MM/YYYY').format('YYYY-MM-DD'),
              naturalidade: this.naturalidade,
              naturalidade_origem: this.naturalidade_origem,
              gemeos: this.gemeos,
              genitores: this.genitores,
            },
            local: { ...this.local },
            data_ocorrido: moment(this.pessoa.data_nascimento, 'DD/MM/YYYY').format('YYYY-MM-DD')
          },
          nascimentoInformacao: {
            ...this.data.nascimentoInformacao,
            idade_mae: this.idade_mae
          },
          ordem_nascimento: this.ordem_nascimento
        }

        return this.$validator.validateAll().then(res => {
          if (res) {
            return this.$emit('updateInfo', obj) }
        })
      },
      upperName () {
        if (this.pessoa.nome) {
          this.pessoa.nome = this.pessoa.nome.toUpperCase()
        }
      },
      cpfDuplicate (genitor) {
        let duplicated = false
        let genitorDuplicado = null

        if (!genitor.pessoa.cpf) return genitorDuplicado

        this.genitores.forEach((gen, index) => {
          if (index != genitor.localId) {
            if (gen.pessoa.cpf && gen.pessoa.cpf.replace(/\D+/g, '') === genitor.pessoa.cpf.replace(/\D+/g, '')) {
              duplicated = true
              genitorDuplicado = gen
            }
          }
        })

        if (genitorDuplicado) {
          objSwal.error.title = `CPF já cadastrado para o genitor ${genitorDuplicado.pessoa.nome}`
          objSwal.error.text = ''
          objSwal.error.html = ''
          Swal.fire(objSwal.error)

          setTimeout(() => {
            const btnConfirm = document.querySelector('.swal2-confirm')

            if (btnConfirm) btnConfirm.focus()
          }, 300)
        }

        return duplicated
      },
      getGenitores (val) {
        if (!this.cpfDuplicate(val)) {
          this.genitores.push(val)

          objSwal.success.title = "Adicionado com Sucesso"
          objSwal.success.text = ''
          Swal.fire(objSwal.success).then(() => {
            setTimeout(() => {
              const btnAdd = window.document.querySelector('.btn-add-genitor')

              if (btnAdd) btnAdd.focus()
            }, 200)
          })

          setTimeout(() => {
            const btnConfirm = window.document.querySelector('.swal2-confirm')

            if (btnConfirm) btnConfirm.focus()
          }, 200)

          this.changeData()
          this.changeTipoNaturalidade()
          this.getIdadeMae()
          this.getNomePai()
        }
      },
      updateGenitor (val, ind) {
        if (!this.cpfDuplicate(val)) {
          this.genitores[ind] = val

          // debugger;
          this.changeData()
          this.changeTipoNaturalidade()
          this.getIdadeMae()
          this.getNomePai()

          objSwal.success.title = 'Genitor atualizado com sucesso!'
          objSwal.success.text = ''
          objSwal.success.html = ''

          Swal.fire(objSwal.success)

          setTimeout(() => {
            const btnConfirm = window.document.querySelector('.swal2-confirm')

            if (btnConfirm) btnConfirm.focus()
          }, 200)
        }
      },
      removeGenitor (localId) {
        const { genitor_id } = this.genitores.find((genitor, index) => index === localId )
        this.genitores = this.genitores.filter((genitor, index) => index !== localId )
        if (genitor_id) this.deleteds.genitores.push(genitor_id)
        this.changeData()
        this.changeTipoNaturalidade()
        this.getIdadeMae()
        this.getNomePai()
      },
      removeGenitorDeclarante (parte_id) {
        const index = this.data.registro.partes.findIndex((parte) => parte.parte_id === parte_id)

        if (index != -1) {
          this.data.registro.partes.splice(index, 1)
          this.deleteds.partes.push(parte_id)
        }

        this.changeData()
      },
      addGemeo (val) {
        this.gemeos.push(val)
        this.changeData()
      },
      removeGemeo (id) {
        const gemeo = this.gemeos[id]

        this.gemeos.splice(id, 1)

        this.deleteds.gemeos.push(gemeo.gemeo_id)

        this.changeData()

        objSwal.success.title = 'Gêmeo removido com sucesso'
        objSwal.success.text = ''

        return Swal.fire(objSwal.success)
      },
      updateFlag (flag) {
        if (!!this.data.registro.pessoa.possui_gemeos_crc) {
          this.$emit('possuiGemeos', flag)
        }
      },
      cleanGemeos () {
        this.gemeos = []
        this.changeData()
      },
      updateGemeo (gemeo) {
        this.gemeos[gemeo.index] = gemeo

        objSwal.success.title = 'Gêmeo atualizado com sucesso'
        objSwal.success.text = ''
        objSwal.success.html = ''

        return Swal.fire(objSwal.success).then(() => this.changeData())
      },
      updateNumDeclaracao (val) {
        this.numero_declaracao_nascido_vivo = val
        this.changeData()
      },
      clearEditOcorrencia (val) {
        this.toEditLocalOcorrencia = val
      },
      receiveOcorrencia (val) {
        this.local = val

        this.changeData()
        this.changeTipoNaturalidade()
      },
      removeOcorrencia () {
        this.deleteError(['LOCAL DO NASCIMENTO', 'LOCAL DA OCORRÊNCIA'])

        this.local = {}
        this.registro.local_ocorrencia_id = null
        this.changeData()

        objSwal.success.title = 'Local de ocorrência excluído'
        objSwal.success.text = ''
        this.changeTipoNaturalidade()
        return Swal.fire(objSwal.success)
      },
      editOcorrencia () {
        this.toEditLocalOcorrencia = { ...this.local }
        this.changeTipoNaturalidade()
      },

      // FUTURAS ATUALIZAÇÕES
      ufChanged () {
        this.naturalidade = ''
        this.changeData()
      },
      naturalidadeChanged () {
        this.localData.naturalidade = this.naturalidade
        this.pessoa.naturalidade = this.naturalidade
        this.pessoa.naturalidade_declarada = this.naturalidade
        this.changeData()
      },
      changeTipoNaturalidade (tipo = null) {
        if (!tipo) {
          tipo = this.naturalidade_origem
        }
        else {
          this.naturalidade_origem = tipo
        }

        const { alerts } = this.naturalidadeControl
        alerts.endereco_mae = false
        alerts.endereco_ocorrencia = false
        alerts.endereco_pai = false

        const showError = (message) => {
          alerts.message = message
          alerts[tipo] = true
          this.naturalidade_origem = null
          this.$emit('receiveError', true)
        }

        const getEnderecoMom = () => {
          // usando filter ao invés de find para caso seja duas mães
          try {
            const genitor = this.genitores.filter(genitor => genitor.pessoa.sexo == "F")[0]

            let endereco = null

            if (genitor) {
              endereco = genitor.pessoa.endereco
            }

            if (!endereco) {
              showError("Mãe com o endereço ainda não informado")
              return
            }

            tratandoEndereco(endereco)
          } catch (e) {
            showError("Mãe com o endereço ainda não informado")
            return
          }
        }

        const getEnderecoPai = () => {
          // usando filter ao invés de find para caso seja duas mães
          try {
            const genitor = this.genitores.filter(genitor => genitor.pessoa.sexo == "M")[0]

            let endereco = null

            if (genitor) {
              endereco = genitor.pessoa.endereco
            }

            if (!endereco) {
              showError("Pai com o endereço ainda não informado")
              return
            }

            tratandoEndereco(endereco)
          } catch (e) {
            showError("Pai com o endereço ainda não informado")
            return
          }
        }

        const getEnderecoOcorrencia = () => {
          try {
            const { endereco } = this.local

            if (!endereco) {
              showError("Local da ocorrência ainda não informado")
              return
            }

            tratandoEndereco(endereco)
          } catch (e) {
            showError("Local da ocorrência ainda não informado")
            return
          }
        }

        const tratandoEndereco = (endereco) => {
          const { cidade, uf, exterior } = endereco

          if (cidade && uf) {
            const naturalidade = `${ cidade } - ${ uf }`
            this.naturalidade = naturalidade
            this.naturalidade_declarada = naturalidade
            this.naturalidade_origem = tipo
            this.naturalidadeChanged()
            this.$emit('receiveError', false)
            return
          }

          let message = null

          if (exterior) {
            message = "O local de ocorrência não pode ser fora do Brasil"
          } else if (!cidade && uf) {
            message = "Cidade não informada"
          } else if (cidade && !uf) {
            message = "UF não informado"
          } else if (!(cidade && uf)) {
            message = "Local ainda não informado"
          }

          showError(message)
        }

        switch (tipo) {
        case 'endereco_ocorrencia':
          getEnderecoOcorrencia()
          break

        case 'endereco_mae':
          getEnderecoMom()
          break

        case 'endereco_pai':
          getEnderecoPai()
          break
        }
      },
      addAvos (genitores) {
        genitores.map((res, index) => {
          this.updateGenitor(res, index)
        })
      },
      updateAvo (avo) {
        const index = this.avosUpdate.findIndex(res => res.avo_id === avo.avo_id)

        if (index >= 0) {
          this.avosUpdate[index] = avo
        } else {
          this.avosUpdate.push(avo)
        }

        this.$emit('updateAvo', this.avosUpdate)
      },
      deleteAvo (id_avo) {
        this.deleteds.filiacao.push(id_avo)
        this.changeData()
      },
      removeDocumento (documento) {
        if (!documento.pessoa_documento_id) return
        this.deleteds.pessoaDocumentos.push(documento.pessoa_documento_id)
        this.changeData()
      },
      removeEndereco (endereco) {
        this.deleteds.pessoaEnderecos.push(endereco.endereco_id)
        this.changeData()
      },
      verifyErrorsCarga () {
        this.error_nome = false
        this.error_sexo = false
        this.error_data = false
        this.error_local_ocorrencia = false

        Object.keys(this.propCorrecoes).forEach(key => {
          if (['NOME DO NASCIDO', 'NOME DO REGISTRADO'].indexOf(key) != -1) this.error_nome = true

          if (['DATA DE NASCIMENTO', 'DATA DE NASCIMENTO'].indexOf(key) != -1) this.error_data = true

          if (['SEXO DO NASCIDO', 'SEXO DO REGISTRADO'].indexOf(key) != -1) this.error_sexo = true

          if (['LOCAL DO NASCIMENTO', 'LOCAL DA OCORRÊNCIA'].indexOf(key) != -1) this.error_local_ocorrencia = true
        })
      },
      deleteError (errors) {
        this.$emit('deleteError', errors)
      },
      getIdadeMae (event = null) {
        const mae = this.genitores.filter(genitor => genitor.pessoa.sexo === 'F')

        if (mae && mae.length) {
          const data_nascimento_mae = moment(mae[0].pessoa.data_nascimento, 'YYYY-MM-DD')
          const data_nascimento_filho = moment(this.pessoa.data_nascimento, 'DD/MM/YYYY')

          if (data_nascimento_mae) {
            const idade_mae = moment(data_nascimento_filho, 'DD/MM/YYYY').diff(data_nascimento_mae, 'years')

            this.idade_mae = idade_mae
          }
        } else {
          this.idade_mae = null
        }

        this.changeData(event)
      },
      getNomePai () {
        const pai = this.genitores.find(genitor => genitor.pessoa.sexo === 'M')

        if (pai) {
          this.nome_pai = pai.pessoa.nome
        } else {
          this.nome_pai = null
        }
      },
      cpfChange () {
        if (!window.validarCPF(this.pessoa.cpf)) {
          objSwal.error.title = 'CPF inválido!'
          objSwal.error.text = 'Informe um cpf em formato válido!'
          this.pessoa.cpf = null
          Swal.fire(objSwal.error)
          return
        }

        // caso for origem CRC n irá acontecer nada
        if (this.pessoa.cpf_origem == 'CRC') return

        if (this.pessoa.cpf) {
          this.pessoa.cpf_origem = 'MANUAL'
        } else {
          this.pessoa.cpf_origem = null
        }
        this.changeData()
      }
    }
  }
</script>

<style lang="scss">
</style>
